import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

export default function AppLayout() {
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <Toaster richColors position="top-right" />
    </div>
  );
}
